export const roleMap = {
  all: '전체',
  student: '학생',
  teacher: '선생님',
  parent: '학부모',
}
